import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, map } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class UnauthedGuard {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    const subscription = this.authService.isLoggedIn();
    subscription.subscribe((is: boolean) => {
      if (is) {
        const nextUrl = next.queryParams['next'] || '';
        this.router.navigate([nextUrl]);
      }
    });
    return subscription.pipe(map((result: boolean) => !result));
  }
}
